<section id="tab-seminabilita">
  <div class="title-tab-colture">
    <h2 class="title-def">{{ 'weather.seedability' | translate }}</h2>
    <h3 class="date-tab-colture">{{ dayTitle$ | async }}</h3>
    <button
      class="btn btn-select btn-circle me-2"
      style="margin-left: 20px"
      [disabled]="!(selectedDay$ | async)"
      (click)="previousDay()"
    >
      <i class="fa-solid fa-chevron-left"></i>
    </button>
    <button
      class="btn btn-select btn-circle"
      [disabled]="(selectedDay$ | async) >= maxDayIndex"
      (click)="nextDay()"
    >
      <i class="fa-solid fa-chevron-right"></i>
    </button>
  </div>
  <div class="container-tabcolture cf">
    <!-- TIME -->
    <div class="cf" id="tab-h-colture">
      <div class="swiper-container slider-h-seminabilita">
        <div class="swiper-wrapper">
          @if (dailyDataSet$ | async; as _dailyDataset) {
            @for (timeItem of _dailyDataset.time; track $index; let i = $index) {
              <div class="swiper-slide" [ngClass]="{ selected: i === selectedIndex }">
                <div class="top-tabcolture">
                  <p class="number-tabcolture">{{ timeItem | date: 'HH' }}</p>
                  <span class="apm-tabcolture">h</span>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
    <!-- CROPS -->
    @for (crop of crops; track $index) {
      <div class="cf tab-type-s" id="tab-xxx">
        <div class="swiper-container slider-seminabilita" [attr.id]="'swiper_' + crop">
          <div class="swiper-wrapper">
            @if (dailyDataSet$ | async; as _dailyDataset) {
              @for (timeItem of _dailyDataset.time; track $index; let i = $index) {
                <div
                  class="swiper-slide"
                  [ngClass]="{
                    selected: i === selectedIndex,
                    v_yes: _dailyDataset[crop][i] === 0,
                    v_may: _dailyDataset[crop][i] === 1,
                    v_not: _dailyDataset[crop][i] === 2,
                  }"
                >
                  <div class="top-hours"></div>
                </div>
              }
            }
          </div>
        </div>
        <div class="name-tabcolture">{{ 'weather.crops.' + crop | translate }}</div>
      </div>
    }
  </div>

  <!-- LEGENDA -->
  <div class="legend-tab">
    <p class="leg v_yes">
      {{ 'weather.seedability' | translate }} {{ 'weather.recommended' | translate }}
    </p>
    <p class="leg v_not">
      {{ 'weather.seedability' | translate }} {{ 'weather.unadvisable' | translate }}
    </p>
    <p class="leg v_may">
      {{ 'weather.seedability' | translate }} {{ 'weather.possibleWithLimitations' | translate }}
    </p>
  </div>
</section>
